import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseResult } from '@app/auth/model';
import { environment } from '@environments/environment';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  private route: string = "student";
  private controller: string = "calendar";
  private endpointPrefix: string;

  constructor(private http: HttpClient) {
    this.endpointPrefix = `${environment.urlAPI}/${this.route}/${this.controller}`;
  }

  getById(studentId: any): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/${studentId}`);
  }

  nextClassEvent(studentId: any): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/nextClass/${studentId}`);
  }

  mockFake(studentId: any): any {
    return this.http.get('https://mocki.io/v1/f7cdb3b1-5572-4503-9d61-a1671432d08b');
  }

  mock(studentId: any): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/mock/${studentId}`);
  }

  mockRange(startDate: Date, endDate: Date): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/mockrange` +
    `/start/${formatDate(startDate, 'yyyy-MM-dd', 'en-US')}` + 
    `/end/${formatDate(endDate, 'yyyy-MM-dd', 'en-US')}`);
  }

  filter(studentId: any, startDate: Date, endDate: Date): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/filter/${studentId}` +
    `/start/${formatDate(startDate, 'yyyy-MM-dd', 'en-US')}` + 
    `/end/${formatDate(endDate, 'yyyy-MM-dd', 'en-US')}`);
  }
}

//return this.http.get<ResponseResult>(`${this.endpointPrefix}/mock/${studentId}/start/${startDate}/end/${endDate}`);

// [HttpGet("mock/{studentId}/start/{startDate}/end/{endDate}")]
// public IActionResult Mock([FromRoute] int studentId, [FromRoute] DateTime startDate, [FromRoute] DateTime endDate)

//[HttpGet("mock/{studentId}/{dateRangeStart}/{dateRangeEnd}")]
//public IActionResult Mock([FromRoute] int studentId, [FromRoute] DateTime dateRangeStart, [FromRoute] DateTime dateRangeEnd)
